export default __webpack_public_path__ + "static/media/36I-114280_-20485_0.847546fb.jpg";